"use client"

import type React from "react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAdminAuth } from "@/contexts/admin-auth-context"
import { Loader2, Shield } from "lucide-react"

export function AdminAuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAdminAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login")
    }
  }, [user, loading, navigate])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            <Shield className="h-12 w-12 text-primary" />
            <Loader2 className="h-6 w-6 animate-spin absolute top-3 left-3" />
          </div>
          <div className="text-center">
            <p className="text-lg font-medium">Verifying Admin Access</p>
            <p className="text-sm text-muted-foreground">Please wait while we authenticate your session...</p>
          </div>
        </div>
      </div>
    )
  }

  if (!user) {
    return null
  }

  return <>{children}</>
}
